import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MsalService } from '@azure/msal-angular';
@Injectable({
  providedIn: 'root'
})
export class IdletimeoutService {
  private readonly IDLE_TIMEOUT = 30 * 60 * 1000; // 30 minutes
  private readonly CHECK_INTERVAL = 60 * 1000;    // Check every 1 minute

  constructor(private router: Router, private ngZone: NgZone, private toastr: ToastrService, private msalService: MsalService,) { }

   startWatching(): void {
 
    sessionStorage.setItem('lastActivityTime', Date.now().toString());
 
    ['click', 'mousemove', 'keydown', 'scroll'].forEach(event => {
      window.addEventListener(event, () => {
        sessionStorage.setItem('lastActivityTime', Date.now().toString());
      });
    });
 
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
 
        const lastActivity = Number(sessionStorage.getItem('lastActivityTime'));
 
        if (!lastActivity) {
          return;
        }
 
        const currentTime = Date.now();
 
        if (currentTime - lastActivity >= this.IDLE_TIMEOUT) {
 
          this.ngZone.run(() => {
            this.logoutForIdle();
          });
 
        }
 
      }, this.CHECK_INTERVAL);
    });
  }
 
  private logoutForIdle(): void {
 
    this.toastr.warning(
      'Application was idle for 30 minutes. Please login again.',
      'Session Expired',
      {
        timeOut: 4000,
        closeButton: true,
        progressBar: true
      }
    );
 
    this.msalService.instance.setActiveAccount(null);
 
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('customToken');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('userName');
    sessionStorage.removeItem('lastActivityTime');
 
    setTimeout(() => {
      this.router.navigateByUrl('/login');
    }, 4000);
  }
}
